export default __webpack_public_path__ + "static/media/gavel3.80fdfa67.jpg";